<template>
  <address class="contact">
    <div class="contact__heading">
      Contact
    </div>

    <p class="contact__address">
      Woonboulevard Poortvliet XXL
      <br>
      Paasdijkweg 33, Poortvliet
    </p>

    <AppOpeningHours class="contact__opening-hours" />

    <p class="contact__route">
      <a
        href="https://www.google.com/maps/dir//Woonboulevard+Poortvliet+XXL,+Paasdijkweg+33,+4693+PA+Poortvliet/@51.5503194,4.1441336,7500m/"
        target="_blank"
        rel="noopener"
      >
        Route naar winkel
      </a>
    </p>

    <p class="contact__phone">
      <a href="tel:+31166619100">0166-619100</a>
      <br>
      (bereikbaar van ma. t/m za.)
    </p>

    <p class="contact__email">
      <a href="mailto:info@wbpoortvliet.nl">info@wbpoortvliet.nl</a>
      <br>
      (binnen 2 werkdagen reactie)
    </p>
  </address>
</template>

<style>
@import url("~layers/app/components/App/Contact.css");
</style>
